module.exports = __webpack_public_path__ + "img/2.257416c7.jpg";